// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap___35L-J","breakAll":"breakAll___1LENz","headRow":"headRow___2NYQD","titleFlush":"titleFlush___3pyfs","dividerGap":"dividerGap___1mNGk"};